module.exports = __webpack_public_path__ + "media/assets/images/blog/man_at_work-e0a2db24c36bb6ef76795aecee1684e1.jpeg";